import React, { useEffect, useState } from 'react';
import { Box, Button, Heading, Layer, Text, TextInput } from 'grommet';
import { Close } from 'grommet-icons';
import PropTypes from 'prop-types';
import { API } from '@enrich/shared-lib';
import QueryString from 'qs';

export const AddToListButton = ({ listId, revalidate }) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <Box>
            <Button
                primary
                size="large"
                label="Add student to list"
                onClick={() => setShowModal(true)}
            />
            {showModal && (
                <AddToListModal
                    listId={listId}
                    revalidate={revalidate}
                    setShowModal={setShowModal}
                />
            )}
        </Box>
    );
};

const AddToListModal = ({ listId, revalidate, setShowModal }) => {
    const [searchInput, setSearchInput] = useState('');
    const [searchResults, setSearchResults] = useState();
    const [selectedContact, setSelectedContact] = useState();
    const [buttonBusy, setButtonBusy] = useState();

    const addtoList = async () => {
        try {
            setButtonBusy(true);
            await API.put(`/api/contact-lists/${listId}`, {
                data: {
                    contacts: {
                        connect: [selectedContact.id],
                    },
                },
            });
            revalidate();
            setShowModal(false);
        } catch (error) {
            setButtonBusy(false);
            console.log(error);
        }
    };

    const handleSelect = (contact) => {
        setSelectedContact(contact);
    };

    useEffect(() => {
        if (!searchInput.length) {
            setSearchResults();
            return;
        }

        searchContacts(searchInput);
    }, [searchInput]);

    const searchContacts = async (searchString) => {
        try {
            const firstNameSearchString = searchString.includes(' ')
                ? searchString.split(' ')[0]
                : searchString;
            const lastNameSearchString = searchString.includes(' ')
                ? searchString.split(' ')[1]
                : searchString;
            const query = QueryString.stringify({
                filters: {
                    $or: [
                        {
                            $and: [
                                {
                                    firstName: {
                                        $containsi: firstNameSearchString,
                                    },
                                },
                                {
                                    lastName: {
                                        $containsi: lastNameSearchString,
                                    },
                                },
                            ],
                        },
                        { firstName: { $containsi: searchString } },
                        { lastName: { $containsi: searchString } },
                        { email: { $containsi: searchString } },
                    ],
                },
                pagination: {
                    limit: 10,
                },
                sort: ['firstName', 'lastName'],
            });

            const contactsResponse = await API.get(`/api/contacts?${query}`);
            const formattedContacts = contactsResponse.data.data.map(
                (contact) => {
                    return {
                        label: `${contact.attributes.firstName} ${contact.attributes.lastName}`,
                        value: contact,
                    };
                },
            );

            setSearchResults(formattedContacts);
        } catch (error) {
            console.log(error);
            return [];
        }
    };

    return (
        <Layer
            onClickOutside={() => setShowModal(false)}
            onEsc={() => setShowModal(false)}
            position="center">
            <Box
                background="white"
                pad="medium"
                round="6px"
                border={{ color: 'enrich-green-light', size: '3px' }}
                alignSelf="center"
                gap="30px">
                <Box direction="row" gap="20px" justify="between">
                    <Heading level="3" margin={{ vertical: 'none' }}>
                        Add contact to list
                    </Heading>
                    <Box align="end">
                        <Close
                            onClick={() => {
                                setShowModal(false);
                            }}
                            cursor="pointer"
                        />
                    </Box>
                </Box>
                <Box>
                    <Box
                        width="medium"
                        align="center"
                        round="6px"
                        background="white">
                        <TextInput
                            dropHeight="medium"
                            onChange={(event) =>
                                setSearchInput(event.target.value)
                            }
                            onSuggestionSelect={(event) =>
                                handleSelect(event.suggestion.value)
                            }
                            placeholder="Search"
                            suggestions={searchResults || []}
                            value={searchInput}
                        />
                    </Box>
                </Box>
                <Box>
                    {selectedContact && (
                        <Box direction="row" gap="small">
                            <Text>
                                {selectedContact.attributes.firstName}{' '}
                                {selectedContact.attributes.lastName}
                            </Text>
                            <Box align="end" justify="center">
                                <Close
                                    size="medium"
                                    color="red"
                                    onClick={() => {
                                        setSelectedContact(null);
                                    }}
                                    cursor="pointer"
                                />
                            </Box>
                        </Box>
                    )}
                </Box>
                <Box>
                    <Button
                        primary
                        busy={buttonBusy}
                        disabled={!selectedContact}
                        label="Add to list"
                        style={{ width: '220px', height: '50px' }}
                        alignSelf="center"
                        onClick={addtoList}
                    />
                </Box>
            </Box>
        </Layer>
    );
};

AddToListButton.propTypes = {
    listId: PropTypes.number,
    revalidate: PropTypes.func,
};

AddToListModal.propTypes = {
    listId: PropTypes.number,
    revalidate: PropTypes.func,
    setShowModal: PropTypes.func,
};
